import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Radio,
  Row,
  Spin,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import Password from "../../../../components/general/password";
import { useQuery } from "@tanstack/react-query";
import { CreateUser, Customer, User, get } from "../../../../api";
import { CanShow } from "../../../../components";
import { useUser } from "../../../../hooks";

type UserFormProps = {
  type: string;
  id?: number | null;
  add: (v: CreateUser) => void;
  update: (v: User) => void;
};

const UserForm: React.FC<UserFormProps> = (props) => {
  const { type, id, add, update } = props;
  const [form] = Form.useForm();
  const [role, setRole] = useState(false);
  const { user } = useUser();
  console.log(user);
  const roleOptions = (type: string) => [
    { label: "ADMIN", value: 1 },
    { label: "FINANCIERO", value: 2 },
    { label: "CLIENTE", value: 4 },
    ...(type !== "add"
      ? [{ label: "PROVEEDOR", value: 3, disabled: true }]
      : []),
  ];

  const { isLoading: isLoadingData, data } = useQuery<User>([type], () =>
    get<User>("/users/" + id).then((e) => e.response),
  );

  const { isLoading: isLoadingCustomers, data: customers } = useQuery<
    Customer[]
  >(["customers"], () => get<Customer[]>("/customers").then((e) => e.response));

  useEffect(() => {
    if (type !== "add" && id) {
      form.setFieldsValue({
        email: data?.email,
        username: data?.username,
        role: data?.role_id,
        customer_id: data?.customer_id,
      });
    }
    setRole(data?.role_id === 4 ? true : false);
  }, [form, data, id, type]);

  const addUserFunction = async (values: any) => {
    if (type === "add") {
      // AGREGAR USUARIO
      let userRequest: CreateUser = {
        email: values.email,
        password: values.password,
        role: user?.customer_id ? 4 : values.role,
        username: values.username,
        customer_id: user?.customer_id ?? values.customer_id,
      };
      add(userRequest);
    } else {
      // EDITAR USUARIO
      values["id"] = id;
      update(values);
    }
  };

  const handleRole = (e: any) => {
    setRole(Number(e.target.value) === 4); // 4 = CUSTOMER
  };

  return (
    <Spin
      spinning={isLoadingData || isLoadingCustomers}
      tip={<p>Cargando...</p>}
    >
      <Form
        name="add-promo"
        layout="vertical"
        form={form}
        onFinish={addUserFunction}
      >
        <Divider />
        <Row style={{ display: "flex", justifyContent: "center" }}>
          <Col xs={20}>
            <Form.Item
              label="Correo electrónico:"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Por favor ingrese un email",
                },
              ]}
            >
              <Input
                type="email"
                placeholder="Ingresa tu información"
                disabled={type !== "add"}
              />
            </Form.Item>
            {type === "add" && <Password type="adduser" />}

            <Form.Item
              label="Nombre de usuario:"
              name="username"
              rules={[
                {
                  required: true,
                  message: "Por favor ingrese un nombre",
                },
              ]}
            >
              <Input
                placeholder="Ingresa tu información"
                disabled={type === "watch"}
              />
            </Form.Item>

            <CanShow roles={["Admin", "Financial Advisor"]}>
              <>
                <Form.Item
                  label="Rol de usuario:"
                  name="role"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese un rol",
                    },
                  ]}
                >
                  <Radio.Group
                    disabled={
                      type === "watch" ||
                      data?.role_description === "Supplier" ||
                      data?.role_description === "Customer"
                    }
                    options={roleOptions(type)}
                    onChange={handleRole}
                    // initialValues={[1]}
                  ></Radio.Group>
                </Form.Item>

                {role && customers && (
                  <Form.Item label="Cliente asociado:" name="customer_id">
                    <Select
                      placeholder="Selecciona una opción"
                      disabled={type !== "add"}
                    >
                      {customers.map((e: any) => (
                        <Select.Option key={e.id} value={e.id}>
                          {e.company_name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </>
            </CanShow>

            <Row justify="end">
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="btn-add"
                  disabled={type === "watch" || isLoadingData}
                >
                  Guardar
                </Button>
              </Form.Item>
            </Row>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default UserForm;
